import React, { useState, useRef, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { IoMdLogOut, IoMdMenu } from "react-icons/io";
import { MdContacts, MdWork } from "react-icons/md";
import {
  IoSpeedometer,
  IoDocumentText,
  IoDownload,
  IoPeople,
  IoWallet,
} from "react-icons/io5";
import { FaShop, FaTag, FaUsers } from "react-icons/fa6";
import { FaBoxOpen } from "react-icons/fa";
import {
  RiFolderAddFill,
  RiFolderSettingsFill,
  RiPriceTag3Fill,
  RiUploadCloud2Fill,
  RiProductHuntFill,
  RiStore3Fill,
  RiSettings4Fill,
  RiImageAddFill,
} from "react-icons/ri";

const Navbar = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const sidebarRef = useRef(null);

  const handleLogout = () => {
    localStorage.removeItem("isLoggedIn");
    localStorage.removeItem("userData");
    navigate("/");
  };

  const toggleSidebar = () => setIsSidebarOpen(!isSidebarOpen);
  const closeSidebar = () => setIsSidebarOpen(false);

  const showNavbar = location.pathname !== "/";

  const navSections = [
    {
      title: "",
      links: [
        { name: "Home", path: "/auth/dashboard", icon: <IoSpeedometer /> },
      ],
    },
    {
      title: "Users",
      links: [
        { name: "Orders", path: "/auth/all-orders", icon: <FaBoxOpen /> },
        {
          name: "View All Products",
          path: "/auth/ProductList",
          icon: <RiProductHuntFill />,
        },
        { name: "Customers", path: "/auth/users", icon: <FaUsers /> },
        { name: "Add Media", path: "/auth/media", icon: <RiImageAddFill /> },
      ],
    },
    {
      title: "Products",
      links: [
        {
          name: "Inventory",
          path: "/auth/inventory",
          icon: <RiProductHuntFill />,
        },
        {
          name: "Add Category",
          path: "/auth/A_product_catalogue/product_catalogue",
          icon: <RiFolderAddFill />,
        },
        {
          name: "Add Sub Category",
          path: "/auth/B_product_sub_catalogue/product_sub_catalogue",
          icon: <RiFolderSettingsFill />,
        },
        {
          name: "Product Variants",
          path: "/auth/D_product_variants/add_product_variant",
          icon: <RiPriceTag3Fill />,
        },
      ],
    },
   
    {
      title: "Channels",
      links: [
        {
          name: "Visit Website",
          path: "/",
          icon: <RiStore3Fill />,
        },
        {
          name: "Settings",
          path: "/auth/settings",
          icon: <RiSettings4Fill />,
        },
      ],
    },
  ];

  // Close sidebar when clicking outside (mobile)
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (sidebarRef.current && !sidebarRef.current.contains(event.target)) {
        closeSidebar();
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    showNavbar && (
      <>
        {/* ====== TOP BAR ====== */}
        <div className="sticky top-0 left-0 right-0 h-14 bg-black border-b border-gray-200 z-[200] flex justify-between items-center px-5 shadow-sm">
          {/* Left: Hamburger + Logo */}
          <div className="flex items-center gap-3">
            {/* Mobile Hamburger */}
            <button
              onClick={toggleSidebar}
              className="md:hidden text-gray-800 bg-gray-100 border border-gray-300 rounded p-1 text-[24px] shadow-sm"
            >
              <IoMdMenu />
            </button>

            {/* Logo */}
            <h1>Admin Dashboard</h1>
          </div>

          {/* Right side */}
          <div className="text-[12px] text-white font-medium">
            Powered by <span className="font-semibold text-gray-400">CSD</span>
          </div>
        </div>

        {/* ====== SIDEBAR ====== */}
        <div
          ref={sidebarRef}
          className={`fixed top-14 left-0 h-[calc(100vh-56px)] w-52 bg-gray-100 border-r border-gray-200 flex flex-col justify-between transition-transform duration-300 ease-in-out z-[150]
            ${
              isSidebarOpen ? "translate-x-0" : "-translate-x-64"
            } md:translate-x-0`}
        >
          {/* Scrollable Menu */}
          <div className="flex-1 overflow-y-auto">
            {navSections.map((section, index) => (
              <div key={index} className="mt-2">
                {section.title && (
                  <p className="text-[10px] uppercase text-gray-400 px-2 font-semibold">
                    {section.title}
                  </p>
                )}
                {section.links.map((link) => {
                  const isActive = location.pathname === link.path;
                  return (
                    <Link
                      key={link.path}
                      to={link.path}
                      onClick={closeSidebar}
                      className={`flex items-center gap-3 px-2 py-2 text-[12px] font-medium rounded-r-full transition-all
                        ${
                          isActive
                            ? "bg-white text-gray-900 border-l-4 border-gray-900"
                            : "text-gray-700 hover:bg-white"
                        }`}
                    >
                      <div
                        className={`text-[18px] ${
                          isActive ? "text-gray-900" : "text-gray-500"
                        }`}
                      >
                        {link.icon}
                      </div>
                      {link.name}
                    </Link>
                  );
                })}
              </div>
            ))}
          </div>

          {/* Logout Button */}
          <div className="border-t border-gray-200 p-3">
            <button
              onClick={handleLogout}
              className="flex items-center gap-3 text-gray-700 hover:text-gray-900 text-[12px] font-medium w-full"
            >
              <IoMdLogOut className="text-[18px] text-gray-500" />
              Logout
            </button>
          </div>
        </div>
      </>
    )
  );
};

export default Navbar;
